export default {"src":"https://cdn.tanzhi.cn/_next/static/media/adhocracy.5d61b19d.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};